/* eslint-disable no-restricted-syntax */
import { useDataModel } from '@thd-nucleus/data-sources';
import { createGraphFromLayoutOperations } from '../Orchestration/layoutUtils';
import { transformDataFromContentful } from '../Orchestration/dataUtils';

const useLayoutOrchestration = ({ variables, layoutDataModel, layoutOptions, ssr }) => {
  const { myComponents, componentOptions, layoutOperations } = layoutOptions;
  let queryName;
  if (!variables.slug) {
    queryName = 'layout';
  } else {
    queryName = 'layouts';
  }

  const contentfulResponse = useDataModel(queryName, {
    variables,
    skip: (!variables.slug && !variables.layoutClass),
    ssr,
    dataModel: layoutDataModel,
  });

  const layout = contentfulResponse.data
    ? transformDataFromContentful([], contentfulResponse.data)
    : null;

  if (!layout) {
    return {
      data: null,
      loading: contentfulResponse.loading,
      error: contentfulResponse.error,
    };
  }

  const sharedLayoutInfo = {
    allComponents: layout,
    myComponents,
    componentOptions,
    layoutOperations,
  };

  const { graph: minWidthLargeGraph, components: minWidthLargeComponents } = createGraphFromLayoutOperations({
    ...sharedLayoutInfo,
    mediaQuery: 'minWidthLarge',
  });

  const { graph: minWidthMediumGraph } = createGraphFromLayoutOperations({
    ...sharedLayoutInfo,
    allComponents: minWidthLargeComponents,
    mediaQuery: 'minWidthMedium',
  });

  // temporary
  const maxWidthMediumGraph = minWidthLargeGraph;

  return {
    data: {
      components: Object.values(minWidthMediumGraph).flatMap((rowComponents) => rowComponents),
      layoutGraphs: {
        maxWidthMedium: maxWidthMediumGraph,
        minWidthMedium: minWidthMediumGraph,
        minWidthLarge: minWidthLargeGraph,
      },
      seo: contentfulResponse.data?.layouts?.seo || null,
    },
    loading: contentfulResponse.loading,
    error: contentfulResponse.error,
  };
};

export default useLayoutOrchestration;
